import { render, staticRenderFns } from "./kuShow.vue?vue&type=template&id=9a2c53e6&scoped=true"
import script from "./kuShow.vue?vue&type=script&lang=js"
export * from "./kuShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2c53e6",
  null
  
)

export default component.exports